import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { analytics } from '../lib/mixpanel'

interface AdminState {
  token: string | null
  refreshToken: string | null
  adminId: string | null
  email: string | null
  name: string | null
  isAuthenticated: boolean
  setAuth: (token: string, refreshToken: string, adminId: string, email: string, name: string) => void
  updateTokens: (token: string, refreshToken: string) => void
  logout: () => void
}

export const useAdminAuthStore = create<AdminState>()(
  persist(
    (set) => ({
      token: null,
      refreshToken: null,
      adminId: null,
      email: null,
      name: null,
      isAuthenticated: false,
      setAuth: (token, refreshToken, adminId, email, name) => {
        analytics.identify({ adminId, email, name })
        analytics.track('Login')
        set({ token, refreshToken, adminId, email, name, isAuthenticated: true })
      },
      updateTokens: (token, refreshToken) => set({ token, refreshToken }),
      logout: () => {
        analytics.track('Logout')
        analytics.reset()
        set({ token: null, refreshToken: null, adminId: null, email: null, name: null, isAuthenticated: false })
      },
    }),
    {
      name: 'omnitrace-platform-admin',
      onRehydrateStorage: () => (state) => {
        if (state?.isAuthenticated && state.adminId && state.email && state.name) {
          analytics.identify({ adminId: state.adminId, email: state.email, name: state.name })
        }
      },
    },
  ),
)
